<template>
  <!-- 提款申请页面 -->
  <div id="withdrawalRequest">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <Input
        class="temr"
        label="借款人姓名"
        v-model="form.borrowerName"
        :readonly="true"
        :labelWidth="labelWidth"
      />

      <div class="company">
        <DrawAmtInput
          class="temr"
          :readonly="true"
          v-model="form.drawAmt"
          :reg="rules.drawAmt"
          :labelWidth="labelWidth"
          :ispayLimit="form.usableAmount"
          label="借款金额"
        />
        <span>元</span>
      </div>
      <SelfSelect
        label="借款期限"
        placeholder="请选择申请期限"
        v-model="form.term"
        :columnsTerm="form.loanTermMap"
        :labelWidth="labelWidth"
      />
      <SelfSelect
        label="借款用途"
        placeholder="请选择借款用途"
        v-model="form.purpose"
        :columnsTerm="purposeMap"
        defaultValue='0'
        :labelWidth="labelWidth"
      />
      <!-- <SelfSelect
        label="放款方式"
        placeholder="请选择放款方式"
        v-model="form.rtnTypes"
        :columnsTerm="form.columnsTermMethod"
        :labelWidth="labelWidth"
      /> -->

      <Input class="temr" placeholder="请输入银行名称" :value="bankName" :readonly="true" :labelWidth="labelWidth" label="银行名称" />
      <Input class="temr" placeholder="请输入银行卡号" v-model="form.classOneCard" :readonly="true" maxlength="30" :labelWidth="labelWidth" type="tel"
        :reg="rules.classOneCard" label="银行卡号" />
      
    </Form>
    <ContractFold text="本人已阅读并完全同意" :api="contractApi" :defaultCheck="false" v-model="agreeState" />
    <SelfButton
      :loading="loading"
      loadingText="提交中..."
      text="提交"
      type="danger"
      :disabled="!isDisabled"
      class="nextStep"
      :click="submitWithdrawalInfo"
    />
  </div>
</template>
<script>
import ContractFold from '@/components/ContractFold.vue';
import { Toast } from 'vant';
import DrawAmtInput from './components/DrawAmtInput.vue';
import SelfSelect from './components/SelfSelect.vue';

export default {
  name: 'withdrawalRequestNew',
  components: {
    DrawAmtInput,
    SelfSelect,
    ContractFold
  },
  data() {
    return {
      agreeState: false,
      contractApi: '/backloansuper/loan/supermarket/contract/list?stage=LOAN',
      labelWidth: '129px',
      loading: false,
      purposeMap: [
        {
          value: '7',
          text: '日常消费',
        }
      ],
      form: {
        orderId: this.$route.query.orderId,
        borrowerName: '', // 借款人姓名
        drawAmt: '', // 借款金额
        term: '', // 借款期限
        purpose: '0', // 借款用途
        classOneCard: '', // 银行卡号
        loanTermMap: [], // 借款期限下拉列表
      },
      banklist: [],
      regular: false,
      rules: {
        term: [{ required: true }],
        purpose: [{ required: true }],
      },
    };
  },
  mounted() {
    const {
      querySupportBanks,
    } = this.$api.CommonForms;
    const { orderId } = this.$router.currentRoute.query;
    querySupportBanks({partnerCreditNo: orderId}).then((res) => {
      if (res && res.data && res.data.result === 'S') {
        this.banklist = res.data.supportBankList.map((item) => ({
          text: item.name,
          value: item.code,
        }));
      } else {
        Toast(res.returnMessage);
      }
    });
    this.getWithdrawalInfo(); // 获取页面反显信息
  },
  watch: {
    
  },
  computed: {
    bankName() {
      const item = this.banklist.find(item => item.value === this.form.bankCode);
      return item ? item.text : '';
    },
    isDisabled() {
      return this.regular&&this.agreeState;
    },
  },
  methods: {
    // 获取页面反显信息
    async getWithdrawalInfo() {
      const { data } = await this.$api.CommonForms.queryLimit({
        orderId: this.$route.query.orderId,
      });
      const supportPeriods = data.supportPeriods.split(',').map(item=>({value: item, text: item+'个月'}));
      this.form = {
        ...this.form,
        ...data,
        loanTermMap:supportPeriods,
      };
    },

    // 提款提交
    async submitWithdrawalInfo() {
      try {
        const { success, returnMessage } = await this.$api.CommonForms.applyLoan(this.form);
        if (success) {
          this.$router.push(`/supermarket/v2/faceRecognitionV2?orderId=${this.$route.query.orderId}&productId=${this.$route.query.productId}`);
        } else {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('提款提交失败');
      }
    },
  },
};
</script>
<style scoped>
#withdrawalRequest {
  width: 100%;
  height: 100%;
  background: #fff;
}
#withdrawalRequest >>> .van-field__label {
  width: 129px;
  margin-right: 0;
  color: #1c2438;
}
.Form{
  margin-bottom: 16px;
}
.temr::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
#withdrawalRequest >>> .van-button--disabled {
  opacity: 1;
  color: #fff;
  background-color: #bac8d1 !important;
  border: 1px solid #bac8d1 !important;
}
.mt8 {
  padding-top: 8px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.company {
  position: relative;
}
.company > span {
  position: absolute;
  top: 12px;
  right: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
}
.company >>> .cross {
  margin-right: 38px;
}
</style>
